import { initBotId } from 'botid/client/core';

// BotID's script rewrites are root-level paths, which Kinsta doesn't proxy for aurorasolar.com/home-solar
export const isBotIdPath = (pathname: string) => !pathname.startsWith('/embed') && !pathname.startsWith('/home-solar');

// BotID makes every protected request wait on its challenge script, and fails or stalls them when that script can't
// load. Protecting only the bot check's own route keeps a failed check from affecting anything else.
const BOT_CHECK_PATH = '/api/bot-check';

export const initBotCheck = () => initBotId({ protect: [{ method: 'POST', path: BOT_CHECK_PATH }] });

// Resolves to the saved verdict, or undefined when the check fails (is_likely_bot stays unset and is retried next load)
export const sendBotCheck = async (): Promise<boolean | undefined> => {
  try {
    const response = await fetch(BOT_CHECK_PATH, { method: 'POST' });
    const { is_likely_bot } = (await response.json()) as { is_likely_bot?: boolean };
    return is_likely_bot;
  } catch {
    return undefined;
  }
};
